var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluidIntake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2012 48.375C31.3783 48.375 35.3844 46.7156 38.3381 43.7619C41.2918 40.8082 42.9512 36.8022 42.9512 32.625C42.9512 28.125 40.7012 23.85 36.2012 20.25C31.7012 16.65 28.3262 11.25 27.2012 5.625C26.0762 11.25 22.7012 16.65 18.2012 20.25C13.7012 23.85 11.4512 28.125 11.4512 32.625C11.4512 36.8022 13.1105 40.8082 16.0642 43.7619C19.0179 46.7156 23.024 48.375 27.2012 48.375Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluidIntake);
export default __webpack_public_path__ + "static/media/FluidIntake.847cb1fdb3806cbd6d1f501e8ad33779.svg";
export { ForwardRef as ReactComponent };